import axios from "axios";

export async function getCoutryCodes() {

    let response = null;
    response = await axios.get('https://restcountries.com/v3.1/region/africa/?fields=idd,altSpellings');
    if (response.status == 200) {
        return response.data;
    }
}